// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BuildFilledSvg from "@ant-design/icons-svg/es/asn/BuildFilled";
import AntdIcon from '../components/AntdIcon';

var BuildFilled = function BuildFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BuildFilledSvg
  }));
};

BuildFilled.displayName = 'BuildFilled';
export default React.forwardRef(BuildFilled);